import { FlexColumn } from '@elementary/common-ui/components';
import { pluralizeString } from '@elementary/common-ui/utils/common';
import { Typography } from '@mui/material';
import { AlertRuleFormDestination } from 'shared/types';
import { fontWeight } from '@elementary/common-ui/style/utils';

type Props = {
  destinations: AlertRuleFormDestination[];
  testsCount: number;
};

const OverrideFormExplanation = ({ destinations, testsCount }: Props) => (
  <FlexColumn sx={{ gap: 1.5 }}>
    {destinations?.length ? (
      <Typography sx={{ fontWeight: fontWeight('medium') }}>
        Custom destinations{' '}
        <Typography component="span" color="content.tertiary">
          {`(${pluralizeString(testsCount, 'test', 'tests')} selected)`}
        </Typography>
      </Typography>
    ) : (
      <FlexColumn gap={1.5}>
        <Typography sx={{ fontWeight: fontWeight('medium') }}>
          Set Custom Alert Destinations
        </Typography>
      </FlexColumn>
    )}
  </FlexColumn>
);

export default OverrideFormExplanation;
